/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./preview-action.vue?vue&type=template&id=05f16354&scoped=true&"
import script from "./preview-action.vue?vue&type=script&lang=js&"
export * from "./preview-action.vue?vue&type=script&lang=js&"
import style0 from "./preview-action.vue?vue&type=style&index=0&id=05f16354&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f16354",
  null
  
)

export default component.exports